import { many, one, } from '@teamworksdev/loco-sync-client';
export const relationshipDefs = {
    Block: {
        focuses: many('BlockFocus', {
            fields: ['id'],
            references: ['blockId'],
        }),
        publishTask: one('BlockPublishTask', {
            fields: ['id'],
            references: ['blockId'],
        }),
        track: one('Track', {
            fields: ['trackId'],
            references: ['id'],
        }),
        transferredAthletes: many('AthleteTransferredBlock', {
            fields: ['id'],
            references: ['blockId'],
        }),
    },
    BlockFocus: {
        focus: one('TrainingFocus', {
            fields: ['focusId'],
            references: ['id'],
        }),
    },
    AthletePublishedWorkoutLayer: {
        block: one('Block', {
            fields: ['blockId'],
            references: ['id'],
        }),
        blockLayer: one('BlockPublishedWorkoutLayer', {
            fields: ['blockId', 'workoutId', 'blockVersion'],
            references: ['blockId', 'workoutId', 'version'],
        }),
        actual: one('AthleteActualWorkoutLayer', {
            fields: ['blockId', 'workoutId', 'profileId'],
            references: ['blockId', 'workoutId', 'profileId'],
        }),
        modifier: one('AthleteModifiedPublishedWorkoutLayer', {
            fields: ['blockId', 'workoutId', 'profileId'],
            references: ['blockId', 'workoutId', 'profileId'],
        }),
        draft: one('AthleteDraftWorkoutLayer', {
            fields: ['blockId', 'workoutId', 'profileId'],
            references: ['blockId', 'workoutId', 'profileId'],
        }),
        blockDraft: one('BlockDraftWorkoutLayer', {
            fields: ['blockId', 'workoutId'],
            references: ['blockId', 'workoutId'],
        }),
    },
};
//# sourceMappingURL=relationships.js.map